import { render, staticRenderFns } from "./HeadLabel.vue?vue&type=template&id=7e40aed7"
import script from "./HeadLabel.vue?vue&type=script&lang=js"
export * from "./HeadLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports